<app-dialog [dialogWithInput]="dialog">
    <app-card>
        <app-paginated-list-data [paginatedService]="service"
                                 [pageSize]="10"
                                 [parameters]="parameters"
                                 [sort]="sort">
            <ng-template let-element='element' template-content>
                <app-tag-item [entity]="element"></app-tag-item>
            </ng-template>
        </app-paginated-list-data>
    </app-card>
</app-dialog>
